import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import { TradeByProductsReportTable } from "./TradeByProductsReportTable";
import { usePageStyles } from "../../../pageStyles";
import { PageComponent } from "../../../../core/navigation/types";
import { PageTitle } from "../../../components/common/PageTitle";
import { TradeByProductsReportFilter } from "./TradeByProductsReportFilter";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";

const TradeByProductsReport: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="exchTradeByProduct" />}
              action={<TradeByProductsReportActions />}
            />
            <Divider />
            <CardContent>
              <TradeByProductsReportTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const TradeByProductsReportActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <TradeByProductsReportFilter />
    </Grid>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
  </Grid>
);

export default TradeByProductsReport;
